import { UseFormSetValue } from 'react-hook-form';
import { AccountSettingsSchema } from '../schema';
import { UserOut } from '@/services/noteGoApi/noteGoApiSchemas';

type UserData = Pick<UserOut, 'first_name' | 'last_name' | 'phone_number'> & { photoURL: string };

export const setUserValues = (userData: UserData, setValue: UseFormSetValue<AccountSettingsSchema>) => {
  setValue('firstName', userData?.first_name || '');
  setValue('lastName', userData?.last_name || '');
  setValue('phoneNumber', userData?.phone_number || '');
  setValue('avatar', userData?.photoURL || '');
};

export const isNameOrNumberChanged = (userData: UserData, formValues: AccountSettingsSchema) => {
  return (
    userData.first_name !== formValues.firstName ||
    userData.last_name !== formValues.lastName ||
    userData.phone_number !== formValues.phoneNumber
  );
};

export const isAvatarChanged = (userData: UserData, formValues: AccountSettingsSchema) => {
  return userData.photoURL !== formValues.avatar;
};
